import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed } from 'vue';
import { ICTA } from '~/types/cta';


export default /*#__PURE__*/_defineComponent({
  __name: 'MomentCard',
  props: {
    backgroundImg: null,
    src: { default: '' },
    title: null,
    buttonText: null,
    compactMode: { type: Boolean, default: false },
    showButton: { type: Boolean, default: true },
    isLoading: { type: Boolean, default: false },
    aspectRatio: null,
    backgroundImageLarge: null,
    backgroundImageSmall: null,
    imgMinHeight: { default: 40 },
    imgMaxHeight: { default: 80 },
    imgMinWidth: { default: 40 },
    imgMaxWidth: { default: 200 },
    containerMinHeight: { default: 160 },
    containerMaxHeight: { default: 200 },
    btnMinWidth: { default: 100 },
    btnMaxWidth: { default: 200 },
    btnMaxHeight: { default: 35 },
    containerClass: { default: 'px-8 py-6' },
    btnDisabled: { type: Boolean, default: false },
    btnClass: { default: 'rounded-pill white text--black font--button px-6 py-3' },
    cta: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { backgroundImg?: string, src: string, title?: string, buttonText?: string, compactMode: boolean, showButton: boolean, isLoading: boolean, aspectRatio?: number, backgroundImageLarge?: string, backgroundImageSmall?: string, imgMinHeight: number, imgMaxHeight: number, imgMinWidth: number, imgMaxWidth: number, containerMinHeight: number, containerMaxHeight: number, btnMinWidth: number, btnMaxWidth: number, btnMaxHeight: number, containerClass: string, btnDisabled: boolean, btnClass: string, cta?: ICTA };



const { $sanityImage, $vuetify } = useContext();
const imgSmCol = computed(() => (props.compactMode ? 4 : 12));
const titleSmCol = computed(() => (props.compactMode ? 8 : 12));
const btnSmCol = computed(() => (props.compactMode ? 12 : 12));

const BG_IMG_WIDTH = computed(() =>
  $vuetify?.breakpoint?.smAndDown ? 300 : 1500,
);
const BG_IMG_HEIGHT = computed(() =>
  $vuetify?.breakpoint?.smAndDown ? 200 : 300,
);
const LOGO_IMG_WIDTH = computed(() =>
  $vuetify?.breakpoint?.smAndDown ? 100 : 100,
);
const LOGO_IMG_HEIGHT = computed(() =>
  $vuetify?.breakpoint?.smAndDown ? 100 : 100,
);
const imgSrc = computed(() => {
  // return props.src;
  return props?.src.includes('image-')
    ? $sanityImage
        .urlFor(props.src)
        .width(LOGO_IMG_WIDTH.value)
        .height(LOGO_IMG_HEIGHT.value)
        .fit('crop')
        .url()
    : !!props.src
    ? props.src
    : require('@/assets/logos/myster-box-rectangle.png');
});

const backgroundImage = computed(() =>
  props?.backgroundImg?.includes('image-')
    ? `url(${$sanityImage
        .urlFor(props.backgroundImg ?? '')
        .width(BG_IMG_WIDTH.value)
        .height(BG_IMG_HEIGHT.value)
        .fit('scale')
        .url()})`
    : props?.backgroundImg
    ? `url(${props.backgroundImg})`
    : '',
);

const bannerStyle = computed(() => {
  const style: Record<string, string> = {};

  if (props.aspectRatio) {
    style['--banner-aspect-ratio'] = `${props.aspectRatio}`;
  }

  if (props.backgroundImageLarge && props.backgroundImageSmall) {
    style['--banner-bg-image-lg-src'] = `url(${props.backgroundImageLarge})`;
    style['--banner-bg-image-src'] = `url(${props.backgroundImageSmall})`;
  } else {
    style['--banner-bg-image-src'] = `url(${
      props.backgroundImageLarge || props.backgroundImageSmall
    })`;
  }

  if (props.backgroundImg) {
    style['background-image'] = backgroundImage.value;
  }

  if (props.containerMinHeight) {
    style['--banner-min-height'] = `${props.containerMinHeight}`;
  }

  if (props.containerMaxHeight) {
    style['--banner-max-height'] = `${props.containerMaxHeight}`;
  }

  if (props.imgMinHeight) {
    style['--img-min-height'] = `${props.imgMinHeight}`;
  }

  if (props.imgMaxHeight) {
    style['--img-max-height'] = `${props.imgMinHeight}`;
  }

  if (props.imgMinWidth) {
    style['--img-min-width'] = `${props.imgMinWidth}`;
  }

  if (props.imgMaxWidth) {
    style['--img-max-width'] = `${props.imgMaxWidth}`;
  }

  if (props.btnMaxHeight) {
    style['--btn-max-height'] = `${props.btnMaxHeight}`;
  }

  if (props.btnMinWidth) {
    style['--btn-min-width'] = `${props.btnMinWidth}`;
  }

  if (props.btnMaxWidth) {
    style['--btn-max-width'] = `${props.btnMaxWidth}`;
  }

  return style;
});

return { __sfc: true,emit, props, $sanityImage, $vuetify, imgSmCol, titleSmCol, btnSmCol, BG_IMG_WIDTH, BG_IMG_HEIGHT, LOGO_IMG_WIDTH, LOGO_IMG_HEIGHT, imgSrc, backgroundImage, bannerStyle }
}

})